export const RESET_VIEW_AFTER_CLOSE_MS = 300
